import React, { useState } from 'react';
import { ListDashItens } from '../../../../../../components/NovoSistema/ListDashItens';
import ModalImageDash from '../../../../../../components/NovoSistema/ModalImageDash';
import SubTitle from '../../../../../../components/NovoSistema/SubTitle';

export default function Indicadores() {
  const [openModal, setOpenModal] = useState(false);
  const prefix = '/docs/controladoria/dashboard/BAF/';
  const nameImage = 'indicadores';
  return (
    <main>
      <SubTitle text="ANÁLISE – Principais indicadores de desempenho financeiro" />
      <ListDashItens>
        <li>Corte: AGO21.</li>
        <li>Indicadores da realização demonstram proporcionalidade estável de variação.</li>
        <li>
          LL em tendência de alta e EBITDA em média estável demonstrando que o mesmo nível de geração de caixa mantém
          melhor lucratividade em razão de ganhos no mercado financeiro.
        </li>
      </ListDashItens>
      <img
        onClick={() => setOpenModal(true)}
        src={`${prefix}${nameImage}.png`}
        alt={nameImage}
        style={{ width: '100%' }}
      />
      {openModal && <ModalImageDash close={setOpenModal} src={`${prefix}${nameImage}.png`} alt={nameImage} />}
    </main>
  );
}
